import React, { useState } from 'react'
import { ItemsRequestModel } from '.'
import { ISearchParam } from '../BaseApp'
import ItemsRequestsApp from './ItemsRequestsApp'
import IssuesApp, { IIssuesModal } from '../issues/IssuesApp'
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer'
import GridData from '../../components/GridData/GridData'
import IssuesList from '../issues/IssuesList'

interface IRequestIssuesProps {
    request: ItemsRequestModel,
    forceRefresh?: (status: boolean) => void,
    forceRefreshStatus?: boolean,
    forceRefreshRequest?: (status: boolean) => void,
}

export default function RequestIssues(props: IRequestIssuesProps) {

    const { request, forceRefresh, forceRefreshStatus, forceRefreshRequest } = props

    const itemsRequestApp = new ItemsRequestsApp()
    const issuesApp = new IssuesApp()

    const [items, setItems] = useState<IIssuesModal[]>([])
    const [pagination, setPagination] = useState<IDataDisplayerPagination>({
        count: 0,
        current_page: 0,
        total_pages: 0
    })
    const [search, setSearch] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(true)
    const [selectedItems, setSelectedItems] = useState<IIssuesModal[]>([])
    const [searchParams, setSearchParams] = useState<ISearchParam[]>([])

    /**
     * Isuses list
     */
    const issuesList = (
        page: number, 
        search: string | null, 
        disablePagination: boolean, 
        addItems?: boolean, 
        searchParams?: ISearchParam[]
    ) => itemsRequestApp.returnRequestIssuesList(request.request_number, page, search, disablePagination, addItems, searchParams)

    const executeAfterCreate = (issues: IIssuesModal) => {
        if (forceRefreshRequest){
            forceRefreshRequest(true)
        }
    }

    return(
        <div className="items-request-issues">
            {/* <GridData
                loading={loading}
                items={items}
                pagination={pagination}
                search={search}
                selectedItems={selectedItems}
                setSelectedItems={(items) => setSelectedItems(items)}
                searchParams={searchParams}
                updateSearch={(search) => setSearch(search)}
                updateLoading={(status) => setLoading(status)}
                updateItemSearchParams={(params) => setSearchParams(params)}
                addNewItem={(item) => {
                    setItems([
                        ...items,
                        item
                    ])
                }}
                updateItem={(item) => {}}
                updateAllItems={(items) => {
                    setItems(items)
                }}
                updateItemsPagination={(pagination) => setPagination(pagination)}
                config={issuesApp.co}
            /> */}
            <IssuesList customHandleLoadItems={issuesList} hidePageHeadSection noSectionBoxWrap disableAddNew forceRefresh={forceRefresh} forceRefreshStatus={forceRefreshStatus} executeAfterCreate={executeAfterCreate} />
        </div>
    )
}